import { Component, OnInit, Input, ChangeDetectionStrategy, Inject, ChangeDetectorRef,
    PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { isPlatformBrowser, isPlatformServer} from '@angular/common';
import { NAVIGATION_LINKS, APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'app-footer',
    templateUrl: 'app-footer.template.html',
    styleUrls: ['app-footer.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppFooter {
    public siteLinks: any;
    public routes: Array<any>;
    public secondary_routes: Array<any>;
    public copyrightYear: string;

    private ngUnsubscribe: Subject<void> = new Subject<void>();
    protected isServer: boolean;
    private cdTriggered: boolean = false;
    constructor(
        private coreEffects: CoreEffects,
        private changeDetector: ChangeDetectorRef,
        @Inject(PLATFORM_ID) private platformId: string,
        @Inject(NAVIGATION_LINKS) private navLinks: Array<Object>,
        @Inject(APP_SETTINGS) private settings: Object
    ) { 
        this.isServer = isPlatformServer(this.platformId);
    }

    ngOnInit() {
        this.siteLinks = this.settings['SHARING_LINKS'];
        this.secondary_routes = this.settings['SECONDARY_FOOTER_ROUTES'];
        this.copyrightYear = new Date().getFullYear().toString();
        
        if (this.isServer){
            this.routes = this.coreEffects.processCmsRoutes([].concat(this.navLinks), false, null);
            if (!this.cdTriggered){
                this.cdTriggered = true;
                this.changeDetector.detectChanges();
            }

        }
        else{
            this.routes = [].concat(this.coreEffects.getCmsRoutesFromStore());
            if (!this.cdTriggered){
                this.cdTriggered = true;
                this.changeDetector.detectChanges();
            }

//             this.coreEffects.getCmsRoutes()
//             .takeUntil(this.ngUnsubscribe)
//             .subscribe(routeRes => {
//                 this.routes = [].concat(routeRes);
//                 if (!this.cdTriggered){
//                     this.cdTriggered = true;
//                     this.changeDetector.detectChanges();
//                 }
    //             for(let route of this.routes){
    //                 if (route.path === this.router.url){
    //                     route.selected = true;
    //                 }
    //             }    
    //          }); 
        }

    }

    ngOnDestroy() {
        if(this.ngUnsubscribe)
        {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
            this.ngUnsubscribe.unsubscribe();
        }
        
    }

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/footer/app-footer.component.ts